export default {"src":"/_next/static/media/footer-dots.bb877e55.gif","height":150,"width":150,"blurWidth":0,"blurHeight":0};